import { render } from "./BottomBtn.vue?vue&type=template&id=07128098&scoped=true"
import script from "./BottomBtn.vue?vue&type=script&lang=ts"
export * from "./BottomBtn.vue?vue&type=script&lang=ts"

import "./BottomBtn.vue?vue&type=style&index=0&id=07128098&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-07128098"

export default script